import { render } from "./SelectJourneySetTemplate.vue?vue&type=template&id=6796ee97&scoped=true"
import script from "./SelectJourneySetTemplate.vue?vue&type=script&lang=ts"
export * from "./SelectJourneySetTemplate.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-6796ee97"

export default script